(function () {
  function currentQuery() {
    var input = document.querySelector('.store-search-form input[name="q"]');
    return null !== input ? input.value.trim() : "";
  }

  function redirect(query) {
    window.location.href = window.routes.search_url + "?q=" + encodeURIComponent(query);
  }

  function cancelEvent(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener(
    "submit",
    function (event) {
      if (null === event.target.closest(".store-search-form")) {
         return;
      }

      cancelEvent(event);
      redirect(currentQuery());
    },
    true,
  );

  document.addEventListener(
    "keydown",
    function (event) {
      if ("Enter" !== event.key || null === event.target.closest('.store-search-form input[name="q"]')) {
        return;
      }

      cancelEvent(event);
      redirect(event.target.value.trim());
    },
    true,
  );

  document.addEventListener(
    "click",
    function (event) {
      var suggestion = event.target.closest(".snize-suggestion");
      var query;

      switch (true) {
        case null !== suggestion:
          query = suggestion.getAttribute("aria-label") || suggestion.textContent.trim();
          break;
        case null !== event.target.closest(".snize-ac-view-all-products"):
          query = "";
          break;
        case null !== event.target.closest("#snize-view-all-link"):
          query = currentQuery();
          break;
        default:
          return;
      }

      cancelEvent(event);
      redirect(query);
    },
    true,
  );
})();
